import { useFormContext, UseFormReturn } from 'react-hook-form';
import { IOrderQuotation } from '../order-quotation-form';

const PRODUCTS_TOTAL_FIELD_NAME: keyof IOrderQuotation = 'products_total';

function setProductsTotal({
    orderQuotationProducts,
    formContext,
}: {
    orderQuotationProducts: IOrderQuotation['order_quotation_products'];
    formContext: UseFormReturn<any>;
}) {
    if (orderQuotationProducts && Array.isArray(orderQuotationProducts)) {
        const products =
            orderQuotationProducts as IOrderQuotation['order_quotation_products'];
        const productsTotal = products.reduce((acc, product) => {
            const kilos =
                Number.isNaN(product.kilos) || !product.kilos
                    ? 0
                    : product.kilos;
            const kiloPrice =
                Number.isNaN(product.kilo_price) || !product.kilo_price
                    ? 0
                    : product.kilo_price;
            const groups =
                Number.isNaN(product.groups) || !product.groups
                    ? 0
                    : product.groups;
            const groupPrice =
                Number.isNaN(product.group_price) || !product.group_price
                    ? 0
                    : product.group_price;

            const productTotal = kilos * kiloPrice + groups * groupPrice;

            return acc + productTotal;
        }, 0);

        formContext.setValue(
            PRODUCTS_TOTAL_FIELD_NAME,
            Math.round(productsTotal * 100) / 100,
            {
                shouldValidate: true,
            },
        );
    }
}

const ORDER_QUOTATION_PRODUCTS_FIELD_NAME: keyof IOrderQuotation =
    'order_quotation_products';

export function useCalculateProductsTotal() {
    const formContext = useFormContext<IOrderQuotation>();

    const calculateProductsTotal = function () {
        const orderQuotationProducts = formContext.getValues(
            ORDER_QUOTATION_PRODUCTS_FIELD_NAME,
        ) as IOrderQuotation['order_quotation_products'];
        setProductsTotal({
            orderQuotationProducts,
            formContext,
        });
    };

    return {
        calculateProductsTotal,
    };
}
